<template>
    <div class="container_linkto">
      <div class="container">
        <div class="content">
          <div class="content-left">
            <Menu :active-name="activeTab" @on-select="selected" width="100px">
              <MenuItem name="gongkai">公开信息披露</MenuItem>
              <MenuItem name="gonggao">重大事项报告</MenuItem>
            </Menu>
          </div>
          <div class="content-right">
            <div class="container" v-show="activeTab === 'gongkai'">
                <h3>公开信息披露</h3>
                <div class="content">
                    <div class="item">
                        <h4>法定名称：</h4>
                        <div>嘉信保险经纪有限公司</div>
                    </div>
                    <div class="item">
                        <h4>法定代表人：</h4>
                        <div>陈旭</div>
                    </div>
                    <div class="item">
                        <h4>注册资本：</h4>
                        <div>人民币5500万</div>
                    </div>
                    <div class="item">
                        <h4>成立时间：</h4>
                        <div>2005年11月21日</div>
                    </div>
                    <div class="item">
                        <h4>机构住所：</h4>
                        <div>广州市天河区兴民路222号之三805室（部位：A）</div>
                    </div>
                    <div class="item">
                        <h4>分支机构：</h4>
                        <div>详见
                            <router-link to="/linkto">关于我们</router-link>
                        </div>
                    </div>
                    <div class="item">
                        <h4>营业执照及保险经营许可证</h4>
                        <Row>
                            <Col span="8" :xs="24" :sm="8">
                            <div class="listItem">
                                <img src="../../assets/card2.jpg" @click="previewImage('../../assets/card2.jpg')" />
                            </div>
                            </Col>
                            <Col span="8" :xs="24" :sm="8">
                            <div class="listItem">
                                <img src="../../assets/card1.jpg" @click="previewImage('../../assets/card1.jpg')" />
                            </div>
                            </Col>
                            <Col span="8" :xs="24" :sm="8">
                            <div class="listItem">
                                <img src="../../assets/card3.png" @click="previewImage('../../assets/card3.png')" />
                            </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
            
            <div class="gonggao-container" v-show="activeTab === 'gonggao'">
                <h3>重大事项报告</h3>
                <div class="gonggao-list">
                    <div class="gonggao-item" v-for="(item, index) in gonggaoList" :key="index" @click="downloadPDF(item.url)">
                        <div class="gonggao-icon">
                            <Icon type="ios-document-outline" size="24" />
                        </div>
                        <div class="gonggao-info">
                            <h4>{{ item.title }}</h4>
                        </div>
                        <div class="gonggao-download">
                            <Icon type="ios-download-outline" size="20" />
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 图片预览模态框 -->
      <div v-if="showPreview" class="image-preview-modal" @click="closePreview">
        <div class="preview-content" @click.stop>
          <div class="preview-header">
            <h3>营业执照预览</h3>
            <Button type="text" @click="closePreview">
              <Icon type="ios-close" size="24" />
            </Button>
          </div>
          <div class="preview-body">
            <img :src="previewImageSrc" alt="营业执照预览" />
          </div>
        </div>
      </div>
    </div>

</template>
<script>
import buslicence from '../../assets/buslicence.png'
export default {
    name: 'index',
    data() {
        return {
            activeTab: 'gongkai',
            showPreview: false,
            previewImageSrc: '',
            gonggaoList: [
                {
                    title: '嘉信保险经纪有限公司关于修改营业场所的公告',
                    url: 'https://gjscrm-1256038144.cos.ap-beijing.myqcloud.com/common/1763911147671/10481816496a4f089e687cbb43b0cccf.pdf'
                },
                {
                    title: '嘉信保险经纪有限公司关于修改广东分公司营业场所的公告',
                    url: 'https://gjscrm-1256038144.cos.ap-beijing.myqcloud.com/common/1763911216634/a4c5a1a876074aa0a794bdc2f63a081e.pdf'
                }
            ]
        }
    },
    methods: {
        selected(name) {
            this.activeTab = name;
        },
        downloadPDF(url) {
            // 创建一个临时链接来下载PDF
            const link = document.createElement('a');
            link.href = url;
            link.download = url.split('/').pop(); // 从URL中提取文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // 或者直接在新窗口打开PDF
            // window.open(url, '_blank');
        },
        previewImage(imageSrc) {
            this.previewImageSrc = imageSrc;
            this.showPreview = true;
            // 防止页面滚动
            document.body.style.overflow = 'hidden';
        },
        closePreview() {
            this.showPreview = false;
            this.previewImageSrc = '';
            // 恢复页面滚动
            document.body.style.overflow = 'auto';
        }
    }
}
</script>
<style scoped lang="less">
@media screen and (max-width: 767px) {
    .container {
        padding-top:64px; 
        font-size: 14px;
    h3 {
      font-size: 18px;
      color: #333333;
      padding: 0 20px 20px;
      margin: 0 20px 40px;
      border-bottom: 1px solid #eaeaea;
      position: relative;
      // &:before {
      //   display: inline-block;
      //   content: "";
      //   height: 26px;
      //   width: 5px;
      //   background-color: #f3981b;
      //   position: absolute;
      //   left: 0;
      //   top: 4px;
      // }
    }
    .content {
      padding: 30px 20px;
      color: #666666;
      .item {
        margin-bottom: 10px;
        h4 {
          color: #333333;
          font-weight: 400;
          font-size: 16px;
        }
        img {
          width: 100%;
          cursor: pointer;
          transition: transform 0.3s;
          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
    .gonggao-container {
        padding-top:64px; 
        font-size: 14px;
        h3 {
            font-size: 18px;
            color: #333333;
            padding: 0 20px 20px;
            border-bottom: 1px solid #eaeaea;
            position: relative;
            // &:before {
            //     display: inline-block;
            //     content: "";
            //     height: 26px;
            //     width: 5px;
            //     background-color: #f3981b;
            //     position: absolute;
            //     left: 0;
            //     top: 4px;
            // }
        }
        .gonggao-list {
            padding: 20px;
            .gonggao-item {
                display: flex;
                align-items: center;
                padding: 15px;
                border-bottom: 1px solid #f0f0f0;
                cursor: pointer;
                transition: background-color 0.3s;
                &:hover {
                    background-color: #f8f8f8;
                }
                .gonggao-icon {
                    margin-right: 15px;
                    color: #f3981b;
                }
                .gonggao-info {
                    flex: 1;
                    h4 {
                        margin: 0 0 5px 0;
                        font-size: 16px;
                        color: #333333;
                        font-weight: 500;
                    }
                    p {
                        margin: 0;
                        font-size: 14px;
                        color: #999999;
                    }
                }
                .gonggao-download {
                    color: #666666;
                }
            }
        }
    }
  }
}
@media screen and (min-width: 768px) {
  .container {
    font-size: 14px;
    h3 {
      font-size: 24px;
      color: #333333;
      padding: 0 20px 20px;
      margin: 0 20px 20px;
      border-bottom: 1px solid #eaeaea;
      position: relative;
      // &:before {
      //   display: inline-block;
      //   content: "";
      //   height: 26px;
      //   width: 5px;
      //   background-color: #f3981b;
      //   position: absolute;
      //   left: 0;
      //   top: 4px;
      // }
    }
    .content {
      padding: 30px 20px;
      color: #666666;
      .item {
        margin-bottom: 10px;
        h4 {
          color: #333333;
          font-weight: 400;
          font-size: 16px;
        }
        .listItem {
          width: 100%;
          height: 320px;
          position: relative;
          img {
            width: 100%;
            position: absolute;
            top: 30px;
            padding: 0 10px;
            box-sizing: border-box;
            cursor: pointer;
            transition: transform 0.3s;
            &:hover {
              transform: scale(1.05);
            }
          }
        }
      }
    }
  }
  .gonggao-container {
    font-size: 14px;
    h3 {
        font-size: 24px;
        color: #333333;
        padding: 0 20px 20px;
        border-bottom: 1px solid #eaeaea;
        position: relative;
        // &:before {
        //     display: inline-block;
        //     content: "";
        //     height: 26px;
        //     width: 5px;
        //     background-color: #f3981b;
        //     position: absolute;
        //     left: 0;
        //     top: 4px;
        // }
    }
    .gonggao-list {
        padding: 20px;
        .gonggao-item {
            display: flex;
            align-items: center;
            padding: 20px;
            border-bottom: 1px solid #f0f0f0;
            cursor: pointer;
            transition: background-color 0.3s;
            &:hover {
                background-color: #f8f8f8;
            }
            .gonggao-icon {
                margin-right: 20px;
                color: #f3981b;
            }
            .gonggao-info {
                flex: 1;
                h4 {
                    margin: 0 0 8px 0;
                    font-size: 18px;
                    color: #333333;
                    font-weight: 500;
                }
                p {
                    margin: 0;
                    font-size: 14px;
                    color: #999999;
                }
            }
            .gonggao-download {
                color: #666666;
            }
        }
    }
  }
}

// 图片预览模态框样式
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.preview-content {
  background: white;
  border-radius: 8px;
  max-width: 90%;
  max-height: 90%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eaeaea;
  
  h3 {
    margin: 0;
    font-size: 18px;
    color: #333333;
  }
}

.preview-body {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  
  img {
    max-width: 100%;
    max-height: 70vh;
    object-fit: contain;
    border-radius: 4px;
  }
}

@media screen and (max-width: 767px) {
  .preview-content {
    max-width: 95%;
    max-height: 95%;
  }
  
  .preview-header {
    padding: 15px;
    
    h3 {
      font-size: 16px;
    }
  }
  
  .preview-body {
    padding: 15px;
  }
}
</style>
<style scoped lang="less" src="../../style/index.less"></style>
<style scoped lang="less" src="./index.less">
</style>



// WEBPACK FOOTER //
// src/page/PublicInfoOpen/index.vue